import { useTimesheet } from '../../hooks';
import { EditableLineManagerComment } from './editable-line-manager-comment';
import { NoneditableLineManagerComment } from './noneditable-line-manager-comment';


export const LineManagerComment = ({ editable, isMasterApproval, children }) => {
  const { timesheet } = useTimesheet();
  const lineManagerComment = timesheet?.lineManagerComments;
  const reviewedByProjectDirector = timesheet?.reviewedByProjectDirector;

  return (
    <>
      
      {(editable && reviewedByProjectDirector) || (editable && isMasterApproval) ? (
        <EditableLineManagerComment lineManagerComments={lineManagerComment}>
          {children}
        </EditableLineManagerComment>
      ) : (
        <>
        <NoneditableLineManagerComment comment={lineManagerComment} />
        
        </>
      )}
      
    </>
  );
};